(function () {
  'use strict';

  /*
   * =========================================================
   * AZVI — CONVERSIÓN USD → VES
   * =========================================================
   */

  const API_URL =
    'https://ve.dolarapi.com/v1/dolares/oficial';

  const CACHE_KEY =
    'azvi_bcv_rate';

  const CACHE_TIME_KEY =
    'azvi_bcv_rate_time';

  const CACHE_DURATION =
    30 * 60 * 1000;

  const REQUEST_TIMEOUT =
    5000;

  const CALCULATING_TIME =
    3000;


  /*
   * =========================================================
   * ESTILOS
   * =========================================================
   */

  function addStyles() {

    if (
      document.getElementById('azvi-bcv-styles')
    ) {
      return;
    }

    const style =
      document.createElement('style');

    style.id =
      'azvi-bcv-styles';

    style.textContent = `

      /*
       * Monto en bolívares
       */

      .azvi-bcv-price {
        display: block;
      }


      /*
       * Texto "Calculando Bs..."
       */

      .azvi-bcv-calculating {
        display: block;
        margin-top: 3px;

        font-size: 0.80em;
        line-height: 1.3;

        color: rgba(18, 47, 82, 0.55);

        font-weight: 400;
      }


      /*
       * Contenedor del texto BCV
       */

      .azvi-bcv-status {
        display: block;

        margin-top: 4px;

        font-size: 0.78em;
        line-height: 1.3;

        color: rgba(0, 115, 255, 1);

        font-weight: 400;

        letter-spacing: 0.01em;

        opacity: 0;

        transform: translateY(3px);

        transition:
          opacity 0.35s ease,
          transform 0.35s ease;
      }


      /*
       * Estado final visible
       */

      .azvi-bcv-status.azvi-bcv-visible {
        opacity: 1;

        transform:
          translateY(0);
      }


      @media screen and (max-width: 749px) {

        .azvi-bcv-calculating {
          font-size: 0.78em;
        }

        .azvi-bcv-status {
          font-size: 0.76em;
        }

      }

    `;

    document.head.appendChild(style);
  }


  /*
   * =========================================================
   * FORMATO VES
   * =========================================================
   */

  function formatVES(value) {

    return new Intl.NumberFormat(
      'es-VE',
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }
    ).format(value);

  }


  /*
   * =========================================================
   * CACHÉ
   * =========================================================
   */

  function getCachedRate() {

    try {

      const rate =
        Number(
          localStorage.getItem(
            CACHE_KEY
          )
        );

      const timestamp =
        Number(
          localStorage.getItem(
            CACHE_TIME_KEY
          )
        );

      if (
        Number.isFinite(rate) &&
        rate > 0 &&
        Number.isFinite(timestamp)
      ) {

        if (
          Date.now() - timestamp <
          CACHE_DURATION
        ) {

          return rate;

        }

      }

    } catch (error) {
      /* Continuar normalmente */
    }

    return null;
  }


  /*
   * =========================================================
   * GUARDAR TASA
   * =========================================================
   */

  function saveRate(rate) {

    try {

      localStorage.setItem(
        CACHE_KEY,
        String(rate)
      );

      localStorage.setItem(
        CACHE_TIME_KEY,
        String(Date.now())
      );

    } catch (error) {
      /* Continuar normalmente */
    }
  }


  /*
   * =========================================================
   * API BCV
   * =========================================================
   */

  async function fetchRate() {

    const controller =
      new AbortController();

    const timeout =
      setTimeout(
        function () {
          controller.abort();
        },
        REQUEST_TIMEOUT
      );

    try {

      const response =
        await fetch(
          API_URL,
          {
            method: 'GET',

            headers: {
              Accept:
                'application/json'
            },

            cache: 'no-store',

            signal:
              controller.signal
          }
        );


      if (!response.ok) {
        return null;
      }


      const data =
        await response.json();


      const rate =
        Number(
          data &&
          data.promedio
        );


      if (
        !Number.isFinite(rate) ||
        rate <= 0
      ) {

        return null;

      }


      return rate;

    } catch (error) {

      return null;

    } finally {

      clearTimeout(timeout);

    }

  }


  /*
   * =========================================================
   * CREAR INDICADOR
   * =========================================================
   */

  function createStatus(element) {

    /*
     * Si ya existe, no crear otro.
     */

    let status =
      element.parentElement.querySelector(
        '.azvi-bcv-status'
      );


    if (status) {
      return status;
    }


    status =
      document.createElement('span');


    status.className =
      'azvi-bcv-status';


    status.textContent =
      'Calculando Bs...';


    /*
     * IMPORTANTE:
     *
     * Lo colocamos DESPUÉS del elemento
     * del precio, no dentro de él.
     */

    element.insertAdjacentElement(
      'afterend',
      status
    );


    return status;
  }


  /*
   * =========================================================
   * PROCESAR PRECIO
   * =========================================================
   */

  function processElement(
    element,
    rate
  ) {

    if (!element) {
      return;
    }


    const usd =
      Number(
        element.dataset.azviUsd
      );


    if (
      !Number.isFinite(usd) ||
      usd < 0
    ) {

      return;

    }


    /*
     * Evitar que MutationObserver
     * reinicie el contador.
     */

    if (
      element.dataset.azviBcvStarted ===
      'true'
    ) {

      return;

    }


    element.dataset.azviBcvStarted =
      'true';


    /*
     * Crear indicador debajo
     * del monto.
     */

    const status =
      createStatus(element);


    /*
     * Mostrar inmediatamente:
     *
     * Calculando Bs...
     */

    status.textContent =
      'Calculando Bs...';


    status.classList.remove(
      'azvi-bcv-visible'
    );


    /*
     * =======================================================
     * ESPERAR 3 SEGUNDOS
     * =======================================================
     */

    setTimeout(
      function () {

        /*
         * Si no tenemos tasa todavía,
         * buscar una nueva.
         */

        if (
          !Number.isFinite(rate) ||
          rate <= 0
        ) {

          fetchRate()
            .then(
              function (freshRate) {

                if (
                  Number.isFinite(
                    freshRate
                  ) &&
                  freshRate > 0
                ) {

                  saveRate(
                    freshRate
                  );


                  showFinal(
                    element,
                    status,
                    usd,
                    freshRate
                  );

                }

              }
            )
            .catch(
              function () {
                /* No romper tienda */
              }
            );

          return;
        }


        showFinal(
          element,
          status,
          usd,
          rate
        );


      },
      CALCULATING_TIME
    );
  }


  /*
   * =========================================================
   * RESULTADO FINAL
   * =========================================================
   */

  function showFinal(
    element,
    status,
    usd,
    rate
  ) {

    if (
      !element ||
      !status
    ) {

      return;

    }


    const ves =
      usd * rate;


    /*
     * El elemento original SOLO contiene
     * el monto en bolívares.
     */

    element.textContent =
      'Bs. ' +
      formatVES(ves) +
      ' VES';

    /*
     * El texto queda totalmente separado
     * debajo del precio.
     */

    status.textContent =
      'Calculado según tasa BCV';


    /*
     * Animación suave.
     */

    requestAnimationFrame(
  function () {

    status.classList.add(
      'azvi-bcv-visible'
    );

  }
);

}
  


  /*
   * =========================================================
   * PROCESAR TODOS
   * =========================================================
   */

  function processAll(rate) {

    const elements =
      document.querySelectorAll(
        '.azvi-bcv-price'
      );


    elements.forEach(
      function (element) {

        processElement(
          element,
          rate
        );

      }
    );

  }


  /*
   * =========================================================
   * OBSERVAR SHOPIFY
   * =========================================================
   */

  function startObserver() {

    if (!document.body) {
      return;
    }


    const observer =
      new MutationObserver(
        function () {

          processAll(
            window.azviBCVRate
          );

        }
      );


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

  }


  /*
   * =========================================================
   * INICIO
   * =========================================================
   */

  async function init() {

    addStyles();


    /*
     * Tasa guardada.
     */

    const cachedRate =
      getCachedRate();


    window.azviBCVRate =
      cachedRate;


    /*
     * Mostrar "Calculando Bs..."
     * inmediatamente.
     */

    processAll(
      cachedRate
    );


    /*
     * Buscar tasa actual sin bloquear
     * la tienda.
     */

    const freshRate =
      await fetchRate();


    if (
      Number.isFinite(freshRate) &&
      freshRate > 0
    ) {

      window.azviBCVRate =
        freshRate;


      saveRate(
        freshRate
      );

    }

  }


  /*
   * =========================================================
   * ARRANCAR
   * =========================================================
   */

  function start() {

    startObserver();


    init().catch(
      function () {
        /* Nunca romper AZVI */
      }
    );

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      start,
      {
        once: true
      }
    );

  } else {

    start();

  }

})();